import { Parser, Tokens } from 'marked';
import { MarkedOptions, MarkedRenderer } from 'ngx-markdown';

// function that returns `MarkedOptions` with renderer override
export function markedOptionsFactory(): MarkedOptions {
    const renderer = new MarkedRenderer();

    // replace paragraph renderer to disable the weird margin-bottom: 1rem
    renderer.paragraph = ({ tokens }: Tokens.Paragraph) => {
        return '<p class="m-0">' + Parser.parseInline(tokens) + '</p>';
    };

    renderer.link = ({ href, title, tokens, text }) => {
        return `<a class="link-primary" href="${href}" target="_blank">${text}</a>`;
    };

    return {
        renderer: renderer,
        gfm: true,
        breaks: false,
        pedantic: false
    };
}
